// extracted by mini-css-extract-plugin
export default {"wrap":"ShowMeStrip_wrap__zIA6p"};